import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class MovimientoPagoService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerPagosRealizados(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_pago {
              obtenerPagosRealizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    documento
                    referencia_documento
                    fecha_registro
                    fecha_vencimiento
                    monto
                    saldo
                    en_recorrido
                    tipo_cargo_codigo
                    cliente_proveedor_rut
                    tipo_movimiento_codigo
                    reversa_pago_codigo
                    reverso_pago_codigo
                    liquidacion_recorrido_pago_codigo
                    pago_codigo
                    saldo_documento_codigo
                    dia_registro
                    mes_registro
                    empresa_rut
                    sucursal_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_pago.obtenerPagosRealizados;
        callback({ mensajes, respuesta });
      }
    );
  }

  cartolaCliente(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_pago {
              cartolaCliente(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    documento
                    pago_codigo
                    fecha_registro
                    fecha_vencimiento
                    referencia_documento
                    monto
                    cargo
                    abono
                    saldo
                    listaPagos {
                      empresa_rut
                      sucursal_codigo
                      codigo
                      tipo_pago_codigo
                      tipo_pago_nombre
                      monto
                    }
                  }
                }
              }
              saldoFinales(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cargo
                  abono
                  monto
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes: mensajesDetalles, respuesta: respuestaDetalles } = response.data.movimiento_pago.cartolaCliente;
        const { mensajes: mensajesTotales, respuesta: respuestaTotales } = response.data.movimiento_pago.saldoFinales;
        callback({
          mensajesDetalles,
          respuestaDetalles,
          mensajesTotales,
          respuestaTotales,
        });
      }
    );
  }

  obtenerCartolaExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_pagoInputType) {
            movimiento_pago {
              obtenerCartolaExcel(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_pago.obtenerCartolaExcel;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerCartolaPDF(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: movimiento_pagoInputType) {
            movimiento_pago {
              obtenerCartolaExcel(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.movimiento_pago.obtenerCartolaExcel;
        callback({ mensajes, respuesta });
      }
    );
  }
}
